import { useConfig } from '@default-config';
import type { CalculatorConfigType } from './calculator-config-type';

export const useCalculatorConfig = (): CalculatorConfigType => {
    const { calculatorConfig } = useConfig();
    return calculatorConfig;
};
